"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComboBoxEndIcon = void 0;
/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const index_js_1 = require("../utils/index.js");
const helpers_js_1 = require("./helpers.js");
exports.ComboBoxEndIcon = React.forwardRef((props, forwardedRef) => {
    const { className, children, onClick: onClickProp, disabled, isOpen, ...rest } = props;
    const dispatch = (0, index_js_1.useSafeContext)(helpers_js_1.ComboBoxActionContext);
    const { toggleButtonRef } = (0, index_js_1.useSafeContext)(helpers_js_1.ComboBoxRefsContext);
    const refs = (0, index_js_1.useMergedRefs)(toggleButtonRef, forwardedRef);
    return (React.createElement("span", { ref: refs, className: (0, classnames_1.default)('iui-end-icon', {
            'iui-actionable': !disabled,
            'iui-disabled': disabled,
            'iui-open': isOpen,
        }, className), onClick: (0, index_js_1.mergeEventHandlers)(onClickProp, () => {
            dispatch({ type: isOpen ? 'close' : 'open' });
        }), ...rest }, children !== null && children !== void 0 ? children : React.createElement(index_js_1.SvgCaretDownSmall, { "aria-hidden": true })));
});
exports.ComboBoxEndIcon.displayName = 'ComboBoxEndIcon';
